var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-input"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('input',{attrs:{"id":_vm.id,"type":"number","min":"0"},domProps:{"value":_vm.realValue},on:{"input":_vm.change}})])}
var staticRenderFns = []

export { render, staticRenderFns }